/* eslint-disable max-classes-per-file */
import { IMarknadsprislista } from "../../../virkeskop/models/marknadsprislista-model";

export interface IAreaSelection {
    typ: string;
    id: number;
}

export class AreaSelectionType {
    static readonly marknadsomrade = "MO";
    static readonly resultatomrade = "RO";
    static readonly produktionsomrade = "PO";
}

export class MarknadsprislistaFilter {
    constructor(
        public resultatomraden: IAreaSelection[],
        public visaEndastVlg: boolean,
        public visaInaktuella: boolean,
        public visaOavsettHsgrupp: boolean
    ) { }

    applyFilter(marknadsprislistor: IMarknadsprislista[], handelssortimentGrupp: number, marknadsprislistaTyper: string[], currentId?: number) {
        const baseFilter =  marknadsprislistor
            .filter(this.hasCorrectHandelssortimentsgruppFilter(handelssortimentGrupp))
            .filter(this.hasCorrectResultatomradeFilter)
            .filter(this.endastVlgFilter)
            .filter(this.typFilter(marknadsprislistaTyper))
            .filter(this.hasMatchingAktualitet);

        if (currentId && !baseFilter.some(p => p.id === currentId)) {
            baseFilter.push(marknadsprislistor.find(p => p.id === currentId));
        }

        return baseFilter;
    }

    isActive() {
        return this.visaEndastVlg ||
            this.resultatomraden.length > 0 ||
            this.visaInaktuella ||
            this.visaOavsettHsgrupp;
    }

    private readonly hasMatchingAktualitet = (marknadsprislista: IMarknadsprislista): boolean => this.visaInaktuella || marknadsprislista.aktuell;

    private readonly endastVlgFilter = (marknadsprislista: IMarknadsprislista): boolean => (this.visaEndastVlg && marknadsprislista.vidLeveransGallande) || !this.visaEndastVlg;

    private readonly hasCorrectResultatomradeFilter = (marknadsprislista: IMarknadsprislista): boolean =>
        this.isIntersected(marknadsprislista.resultatomraden.map(p => p.id), this.resultatomraden.map(p => p.id))
            || this.resultatomraden.length === 0;

    private isIntersected<T>(listA: T[], listB: T[]) {
        return listA.filter(value => -1 !== listB.indexOf(value)).length > 0;
    }

    private readonly typFilter = (typer: string[]) =>
        (marknadsprislista: IMarknadsprislista): boolean => typer.includes(marknadsprislista.typ);

    private readonly hasCorrectHandelssortimentsgruppFilter = (handelssortimentGrupp: number) =>
        (marknadsprislista: IMarknadsprislista): boolean => this.visaOavsettHsgrupp ||
                marknadsprislista.handelssortimentsgrupper.map(grupp => grupp.id)
                    .indexOf(handelssortimentGrupp) >=
                0;
}
